/*
 * @Description:
 * @Autor: Sia
 * @Date: 2019-11-06 11:40:31
 * @LastEditors  : Sia
 * @LastEditTime : 2020-01-17 10:00:50
 */
import axios from "axios";
import router from "../router";
import store from "./store";
import ElementUI from "element-ui";

// 添加请求拦截器
// let axios = $axios.create({
//   headers: {'Content-Type': 'application/json; charset=utf-8'},
//   baseURL: 'http://118.89.112.142/report'
// })
// axios.defaults.baseURL = "http://localhost:8080"; //  本地
// axios.defaults.baseURL = "http://118.89.112.142:8100/report"; // 测试
// axios.defaults.baseURL = "https://bi.lannlife.com/report"; // 生产

axios.defaults.baseURL = "http://124.220.221.147:8100/report"; // 测试
axios.defaults.baseURL = process.BASE_URL; // 生产
// setTimeout(() => {
//   console.log(Vue.prototype.BASE_URL)
// })
// axios.defaults.baseURL = Vue.prototype.BASE_URL
axios.defaults.timeout = 100000;
axios.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const token = store.state.token || sessionStorage.getItem("token");
    const tokenName = store.state.tokenName || sessionStorage.getItem("tokenName");
    if (token && tokenName) {
      config.headers[tokenName] = token;
    }
    return config;
  },
  function (error) {
    // 对请求错误做些什么k
    return Promise.reject(error);
  }
);
// 添加响应拦截器
axios.interceptors.response.use(
  function (response) {
    if (response.config.skipResponseInterceptor) return response
    if(response.data.errorCode) { //旧版本拦截器控制
      if (response.data.errorCode !== 0 && response.data.errorCode !== 1001) {
        ElementUI.Message.error(response.data.errorMsg);
        store.state.noData = true;
      }
    } else if (response.data.code) {  //新版本拦截器控制
      if (response.data.code !== '0' ) {
        ElementUI.Message.error(response.data.message);
        store.state.noData = true;
      }
    }
    return response;
  },
  function (error) {
    console.log(error)
    // 对响应错误做点什么
    if (error.response && error.response.status) {
      switch (error.response.status) {
        case 404:
          ElementUI.Message.error("接口不存在！");
          break;
        case 401:
          router.replace({
            path: "/login",
            query: {
              redirect: router.currentRoute.fullPath
            }
          });
          localStorage.clear();
          sessionStorage.clear();
          break;
        case 504:
          ElementUI.Message.error("获取数据超时！");
          break;
        case 500:
          ElementUI.Message.error("获取数据发生错误！");
          break;
        default:
      }
    }
    return Promise.reject(error);
  }
);

export default axios;
